import React, { useState } from 'react';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import helper from "../Shared/helper";

export const DateSelectFilterCell = (props) => {
    const [value, setValue] = useState(props.defaultItem);

  const onChange = (event) => {
    setValue(event.target.value);
    const currentDate = new Date()
    let dateTime = new Date(currentDate.getTime() - 60 * 60 * 1000);
    if(event.target.value === '24 Hours Ago') {
        dateTime = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
    }
    if(event.target.value === 'One Week Ago') {
        dateTime = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
    }
    if(event.target.value === 'One Month Ago') {
        dateTime = new Date(currentDate.getTime() - 31 * 24 * 60 * 60 * 1000);
    }

    props.onChange({
      value: dateTime,
      operator: "gte",
      syntheticEvent: event.syntheticEvent,
    });
  };

  return (
    <div className="k-filtercell">
      <DropDownList
        data={props.data}
        onChange={onChange}
        value={value}
        defaultItem={props.defaultItem}
      />
    </div>
  );
};